import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormikProps } from 'formik';
import { cleanObj } from '../../../../../shared/utils/objects';
import { ToastSwal } from '../../../../components/general/toastSwals/toastSwal';
import { ISelect } from '../../../../../shared/types/shared';
import { Quotation } from '../../../../../shared/types/modules/quotation';
import {
    asyncCreateQuotation,
    asyncGetQuotation,
    asyncUpdateQuotation,
    asyncSendTemplateQuotation,
} from '../../../../../services/quotation.service';
import { QUOTATION, QUOTATION_DETAIL } from '../../../../../routes/paths';

export const useQuotationForm = () => {
    const navigate = useNavigate();
    const { idQuotation } = useParams();
    const { idAccount } = useParams();
    const [quotationDetail, setQuotation] = useState<Quotation>();
    const [loading, setLoading] = useState(false);
    const [formikQuotation, setFormikQuotation] =
        useState<FormikProps<Quotation>>();

    const isValidForm = formikQuotation?.isValid;

    const handleSubmit = async () => {
        await formikQuotation?.submitForm();

        if (!isValidForm) return;

        setLoading(true);

        const data: Quotation = cleanObj(formikQuotation?.values) || {};

        data.account = quotationDetail?.account?.id || idAccount;

        let res: Quotation | undefined = undefined;

        try {
            if (quotationDetail && quotationDetail.id)
                res = await asyncUpdateQuotation(quotationDetail.id, data);
            else {
                res = await asyncCreateQuotation(data);
                if (res?.account?.email) {
                    asyncSendTemplateQuotation(data, res?.account?.email);
                }
            }
        } catch (error) {}
        if (res) {
            ToastSwal.fire({
                text: `¡Felicidades! La cotización se ${
                    quotationDetail && quotationDetail.id ? 'actualizo' : 'creó'
                } satisfactoriamente con ID: ${res.id}`,
                icon: 'success',
                timer: 5000,
                position: 'center-end',
            });
            navigate(`${QUOTATION_DETAIL}/${res.id}`);
        } else {
            ToastSwal.fire({
                text: `Lo sentimos, no se pudo ${
                    quotationDetail && quotationDetail.id
                        ? 'actualizar'
                        : 'crear'
                } el caso. Por favor, asegúrate de diligenciar los datos correctamente e intenta nuevamente más tarde.`,
                icon: 'error',
                timer: 5000,
                position: 'center-end',
            });
        }

        setLoading(false);
    };

    const handleClean = () => {
        formikQuotation?.resetForm();
    };

    useEffect(() => {
        if (Boolean(idQuotation?.trim())) {
            setLoading(true);
            asyncGetQuotation(idQuotation?.trim())
                .then((res) => {
                    if (!res || !res.id) navigate(QUOTATION);

                    [res].forEach((item: any) => {
                        if (item)
                            Object.keys(item).forEach((key) => {
                                if (item?.[key] && (item?.[key] as ISelect)?.id)
                                    item[key] = (
                                        item[key] as ISelect
                                    )?.id.toString();
                            });
                    });

                    setQuotation(res);
                })
                .finally(() => setLoading(false));
        }
    }, [idQuotation]);

    return {
        quotationDetail,
        idAccount,
        loading,
        isValidForm,
        handleSubmit,
        handleClean,
        formikQuotation,
        setFormikQuotation,
    };
};
